//开发环境
const DEV = "https://api.test.lis.ulabcare.com/api/";
// const DEV = "http://192.168.3.86:8080/api/";

//生产环境
const PROD = "https://api.lis.ulabcare.com/api/";

export const baseURL = PROD;




// WEBPACK FOOTER //
// ./src/config/index.js